import * as React from "react";
import Provider from "./Store/Provider";
import { createRoot } from 'react-dom/client';

const container = document.getElementById('react');
const root = createRoot(container);
root.render(<Provider/>);